import { useTranslation } from "react-i18next";
import React from "react";
import PageWrapper from "../../../components/common/layout/PageWrapper";
import { GridSpg, useRedirect, SecurityGuard, SecurityRole } from "@duosoftbg/nacid-components";
import { CardContent as MuiCardContent } from "@mui/material";
import MuiCard from "@mui/material/Card";
import MuiCardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import { ProcessEnvironments } from "@duosoftbg/nacid-frontoffice-components";

const StyledCard = styled(MuiCard)<{ cardColor: string }>`
  background-color: rgb(255, 255, 255);
  color: rgb(30, 32, 34);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 3px 6px 0px;
  overflow: hidden;
  border-radius: 0px 0px 8px 8px;
  border-top: ${(props) => `2px solid ${props.cardColor}`};
  height: 100%;
  position: relative;
`;

const CardActions = styled(MuiCardActions)`
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`;

const CardContent = styled(MuiCardContent)`
  padding-bottom: 55px;
`;
const PersonalContent = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.header.personalContent")}>
      <GridSpg container spacing={10}>
        <GridSpg item xs={12} sm={6} md={6} lg={6}>
          <Card
            cardBorderColor={"rgb(23,168,0)"}
            title={"l.myApplications"}
            to={`${ProcessEnvironments.Module.FrontOffice.Services}/my-applications`}
            description={"m.myApplications.description"}
          />
        </GridSpg>
        <GridSpg item xs={12} sm={6} md={6} lg={6}>
          <Card
            cardBorderColor={"rgb(255, 111, 0)"}
            title={"l.myPayments"}
            description={"m.myPayments.description"}
            to={`${ProcessEnvironments.Module.Common.Payments}/user-payments`}
          />
        </GridSpg>
        <GridSpg item xs={12} sm={6} md={6} lg={6}>
          <Card
            cardBorderColor={"rgb(0,102,255)"}
            title={"l.myCorrespondence"}
            to={`${ProcessEnvironments.Module.FrontOffice.Services}/my-correspondence`}
            description={"m.myCorrespondence.description"}
          />
        </GridSpg>
        <SecurityGuard displayOnUnauthorized={false} checkForRoles={[SecurityRole.AcadrecUniEntryRequestCreate]}>
          <GridSpg item xs={12} sm={6} md={6} lg={6}>
            <Card
              cardBorderColor={"rgb(255,198,10)"}
              title={"l.arUniEntryRequest"}
              to={`${ProcessEnvironments.Module.FrontOffice.Registers}/ar-uni-entry-request`}
              description={"m.arUniEntryRequest.description"}
            />
          </GridSpg>
          <GridSpg item xs={12} sm={6} md={6} lg={6}>
            <Card
              cardBorderColor={"rgb(191,41,208)"}
              title={"l.arUniEntryRequest.list"}
              to={`${ProcessEnvironments.Module.FrontOffice.Registers}/ar-uni-entry-request/list`}
              description={"m.arUniEntryRequest.list.description"}
            />
          </GridSpg>
        </SecurityGuard>
      </GridSpg>
    </PageWrapper>
  );
};

const Card = ({ title, description, buttonLabel = "l.btn.view.v2", to = "", cardBorderColor }) => {
  const { t } = useTranslation();
  const { redirectWithEvent } = useRedirect();

  return (
    <StyledCard cardColor={cardBorderColor}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {t(title)}
        </Typography>
        <Typography variant="body2" color="text.secondary" align={"justify"}>
          {t(description)}
        </Typography>
      </CardContent>
      <CardActions>
        <Button onClick={redirectWithEvent(to)}>{t(buttonLabel)}</Button>
      </CardActions>
    </StyledCard>
  );
};

export default PersonalContent;
